import { Dropdown } from 'react-bootstrap';
import { useProfile } from '../contexts/ProfileContext';
import { useState } from 'react';
import RegisterSocial from './RegisterSocial';
import { Modal } from 'react-bootstrap';
import axios from 'axios';
import { useLanguage } from '../contexts/LanguageContext';

const ProfileSwitcher = () => {
    const L = useLanguage();
    const profile = useProfile();
    const photo = profile?.socials?.[profile?.selectedProfile]?.photo || "/images/default.png";
	const defaultPhoto = "/images/default.png";
    const username = profile?.socials?.[profile?.selectedProfile]?.username;
    const platform = profile?.socials?.[profile?.selectedProfile]?.platform;
    const growthRate = profile?.socials?.[profile?.selectedProfile]?.growthRate;
    const [showRegisterSocial, setShowRegisterSocial] = useState(false);
    const [selectedProfile, setSelectedProfile] = useState(profile.selectedProfile || "");

    const addAccount = () => {
        setShowRegisterSocial(true);
    };

    const selectProfile = (uuid) => {
        setSelectedProfile(uuid);
        axios.post("https://api.viralgpt.com/auth/select", {
            profileid: uuid
        }, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`
            }
        })
        .then(response => {
            window.location.reload();
        })
        .catch(error => {
            console.error("Error selecting profile:", error);
        });
    };
    return (
        <>
        <Modal show={showRegisterSocial} onHide={() => setShowRegisterSocial(false)} centered size="lg">	
          <Modal.Header closeButton>	
              <Modal.Title>{L.profileSwitcher.addAccount}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
              <RegisterSocial 
                  show={showRegisterSocial}
                  onHide={() => setShowRegisterSocial(false)}
              />
          </Modal.Body>
      </Modal>
 
      <Dropdown >
        <Dropdown.Toggle variant="link" className="bg-white p-0 text-decoration-none w-100" style={{caretColor: "transparent"}}>
          <div className="flex items-center space-x-4 border-2 border-gray-200 rounded-lg p-2" style={{minWidth: "350px"}}>
			
		  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true" data-slot="icon" className="w-6 h-6 text-gray-500"><path stroke-linecap="round" stroke-linejoin="round" d="M8.25 15 12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"></path></svg>
            <div className="flex-shrink-0">
				
              <div className="relative">
                <div className="relative flex flex-col items-center space-y-1">
                  <div className="background-animate rounded-full bg-gradient-to-r p-[0.17rem] from-fuchsia-500/80 via-red-600/50 to-orange-400/50">
                    <div className="block p-1 transition transform bg-white rounded-full">
                      <img 
                        className="h-[60px] w-[60px] rounded-full"
                        src={photo}
                        onError={(e) => { e.target.onerror = null; e.target.src = '/images/default.png'; }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="my-auto">
              <div className="flex items-center">
                <h1 className="inline text-[21px] font-bold text-gray-800 font-dashboard tracking-tight  items-center">
					{platform === "x" ? (
						<span className="bg-black px-1 rounded-md text-white">𝕏</span>
					) : (
						<i className={`fa-brands fa-${platform} text-${platform}-dark`}></i>
					)}
                  <span className="ml-2 ">{username?.length > 16 ? `${username.slice(0, 16)}...` : username}</span>
                </h1>
              </div>
              <div className="flex gap-2">
                {profile?.socials?.[profile?.selectedProfile]?.planName === "pro" && (
                  <span className="border flex items-center rounded-lg px-2 py-1 text-xs font-semibold tracking-normal text-white w-fit bg-instagram">
                    <i className="fas fa-crown mr-1"></i>
                    {L.profileSwitcher.badgePro}
                  </span>
                )}
                {profile?.socials?.[profile?.selectedProfile]?.planName === "basic" && (
                  <span className="border flex items-center rounded-lg px-2 py-1 text-xs font-semibold tracking-normal text-white w-fit bg-dark">
                   
                    {L.profileSwitcher.badgeBasic}
                  </span>
                )}
                {profile?.socials?.[profile?.selectedProfile]?.planName === "starter" && (
                  <span className="border flex items-center rounded-lg px-2 py-1 text-xs font-semibold tracking-normal text-white w-fit bg-secondary">
                   
                    {L.profileSwitcher.badgeStarter}
                  </span>
                )}
              </div>
            </div>
          </div>
        </Dropdown.Toggle>

        <Dropdown.Menu className="w-100 mt-2">
          {profile?.socials && Object.entries(profile.socials).map(([key, social]) => (
            <Dropdown.Item 
              key={key}
              className={`d-flex align-items-center w-100 ${social.profileid === selectedProfile ? 'bg-light' : ''}`}
              onClick={() => selectProfile(social.profileid)}
            >
			
              <img 
                src={social.photo ? social.photo : defaultPhoto}
                alt="Profile"
                className="rounded-circle me-2"
                style={{width: "30px", height: "30px"}}
                onError={(e) => { e.target.onerror = null; e.target.src = '/images/default.png'; }}
              />
			  <div className="w-6">
				{social.platform === 'x' ? (

					<span className="bg-black rounded-md text-white"><i className={`fa-brands fa-twitter-x text-${social.platform || platform}`}></i></span>
					

				) : (
					<i className={`fa-brands fa-${social.platform || platform} text-${social.platform || platform} me-1`}></i>
				)}
			  </div>
			  
              {social.username.length > 16 ? `${social.username.slice(0, 16)}...` : social.username}
              <div className="ms-auto d-flex align-items-center">
                <span className={`badge ${social.planName === 'pro' ? 'bg-instagram' : social.planName === 'basic' ? 'bg-dark' : social.planName === 'starter' ? 'bg-secondary' : 'bg-gray-400'}`}>
                  {(social.planName === 'pro' ? L.profileSwitcher.badgePro : social.planName === 'basic' ? L.profileSwitcher.badgeBasic : social.planName === 'starter' ? L.profileSwitcher.badgeStarter : L.profileSwitcher.badgeNoPlan).toUpperCase()}
                </span>
				
                <i className={`fas ${social.profileid === selectedProfile ? 'fa-check text-instagram' : 'fa-check text-transparent'} ms-2`}></i>
              </div>
            </Dropdown.Item>
          ))}
          <Dropdown.Divider />
          <Dropdown.Item onClick={() => addAccount()} className="w-100">
            <i className="fas fa-plus me-2"></i>
            {L.profileSwitcher.addAnotherAccount}
			
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
	  </>
    );
};

export default ProfileSwitcher;